import Vue from 'vue'
import Vuetify from 'vuetify/lib/framework'

/*
 * 일렉트론과 같은 a-la-carte 방식 (vuetify-loader 가 실제로 쓴 컴포넌트의 스타일만 넣는다).
 * full vuetify.min.css 를 통째로 넣으면 .v-application 의 .title/.info/ol/ul 같은 전역
 * 타이포 reset 이 예약 화면 마크업과 부딪혀 스타일이 달라 보인다.
 */
Vue.use(Vuetify)

const vuetify = new Vuetify({})

export default vuetify
